<script lang="ts">
  import ModalBase from './ModalBase.svelte';
</script>

<ModalBase {...$$restProps}></ModalBase>
